/*
 * @创建人: 张润
 * @修改人: 但志强
 * @描述: 组合查询
 * @创建时间: 2019-07-25 10:46:54
 * @修改时间: 2019-08-05 17:26:08
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
import { SwModalframeComponent } from '../../sw-modal-frame/sw-modal-frame.component';


/**
 * 组合查询  sw-concat-select
 */
@Component({
  selector: 'sw-concat-select',
  templateUrl: './sw-concat-select.component.html',
  styleUrls: ['./sw-concat-select.component.css']
})
export class SwConcatSelectComponent implements OnInit {

  /**
   * 点击查询事件抛出 eg:[{code：'' ,value:''}]
   */
  @Output() onConcatSelect = new EventEmitter;
  
 /**
  * 参与组合查询的所有字段数据 eg: {id:1,text:'地理及位置',code:'address'},
  */
  @Input() concatData:any=[]

  /**
   * 弹出框组件
   *  @ignore
   */
  @ViewChild("swmodef") swmodef :SwModalframeComponent

  /**
  * @ignore
  */
  constructor(private box:SwMassageBoxService) {}
   /**
   * 查询条件数据
   * @ignore
   */
  operation = [
    {id:1,text:'相等',code:'eq'},
    {id:2,text:'不相等',code:'not'},
    {id:3,text:'相似',code:'like'},
    {id:4,text:'包括在',code:'in'},
    {id:5,text:'不包括',code:'not in'},
  ]
  /**
   * @ignore
   */
  link = [
    {id:1,text:'并且',code:'and'},
    {id:2,text:'或者',code:'or'},
  ];

  /**
   * 新增一条查询数据
   * @ignore
   */
  Kong:any =  {
    field: 0,
    operation: 0,
    value: '',
    link: 0,
    data:{}

  };
  /**
   * 键值对检索条件。
   * @ignore
   */ 
  conditions = [];

  /**
   * 表单上的字段信息
   * @ignore
   */
  fieldArr :any= []

  /**
   *  @ignore
   */
  ngOnInit() {
    // 默认单条空数据
    this.fieldArr.push(JSON.parse(JSON.stringify(this.Kong)));
  }

  /**
   * 弹出模态框
   * @ignore
   * @memberof SwDeepSelectComponent
   */
  clickConcatBtn(e) {
    this.swmodef.toggle(); 
  }

  /**
   * 添加一条数据
   * @ignore
   */
  addCondition(){
    if (!this.fieldArr[this.fieldArr.length-1].field)
      this.box.danger("请填写完所有数据")
    else if (!this.fieldArr[this.fieldArr.length-1].operation)
      this.box.danger("请填写完所有数据")
    else if (!this.fieldArr[this.fieldArr.length-1].value)
      this.box.danger("请填写完所有数据")
    else if (!this.fieldArr[this.fieldArr.length-1].link)
      this.box.danger("请填写完所有数据")
    else   
      this.fieldArr.push(JSON.parse(JSON.stringify(this.Kong)));
  }


  /**
   * 组合查询
   * 根据每条字段的状态信息组合成可供检索的键值对，并发射出去
   * @memberof SwConcatSelectComponent
   * @ignore
   */
  cancatSelect(){
    this.conditions = [];
    this.fieldArr.map(item=>{
      let obj = {}
      try{
        obj['code'] = this.concatData.filter(i=>{return i.id==item.field})[0].code;
        obj['link'] = this.link.filter(i=>{return i.id==item.link})[0].code;
        obj['operation'] = this.operation.filter(i=>{return i.id==item.operation})[0].code;
        obj['value'] = item.value;
        this.conditions.push(obj);
      }catch(e){
        return;
      }

    });
    this.onConcatSelect.emit(this.conditions);
  }

  /**
   * 重新选择查询项修改数据
   * @ignore
   * @param event 选中的数据
   * @param i  id
   */
  clickChange(event,i){
    this.fieldArr[i].data = this.concatData.find(x=>x.id == event.id);
    this.fieldArr[i].value = null;
  }

  /**
   * 删除一条数据
   * @param index  下标
   * @ignore
   */
  deleteOneData(index){
    if(index>0)
      this.fieldArr.splice(index,1);
  }
}
